<template>
  <DialogProfileItemTemplate :disabled="disabled" :class="{ disabled }">
    <template #image>
      <component
        :is="component"
        :to="`/mon-compte/ajouter-un-membre`"
        class="add"
        @click="dialogClose"
      >
        <div class="solid" />
        <icon name="plus" size="5rem" />
      </component>
    </template>
    <template #label> Ajouter </template>
  </DialogProfileItemTemplate>
</template>
<script setup lang="ts">
interface Props {
  to?: string;
  disabled: boolean;
}
const props = defineProps({
  to: null,
  disabled: { type: Boolean }
});
const dialog = useDialogStore();
const component = computed(() => {
  if (props.disabled) {
    return 'span';
  }
  return resolveComponent('NuxtLink');
});
const dialogClose = () => {
  if (props.disabled) return null;
  else return dialog.close();
};
</script>
<style lang="scss" scoped>
.add {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: auto;
  font-size: 6rem;
  font-weight: 700;
  aspect-ratio: 1;
  .solid {
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: transform 300ms $ease-in-back;
    border-radius: 50%;
    background-color: var(--color_secondary_light);
  }
  .icon {
    position: relative;
    transition: transform 300ms $ease-in-back;
  }
}
button.add {
  &:hover,
  &:focus {
    .solid {
      transform: scale(1.02);
      transition: transform 300ms $ease-out-back;
    }
    .icon {
      transform: scale(1.05) rotate(90deg);
      transition: transform 500ms $ease-out-back;
    }
  }
}
.disabled {
  .add {
    opacity: 0.1;
    cursor: auto;
  }
}
</style>
